










































import moment from "moment/moment";
import { RapportFav } from "@/shared/Rapport";
import Component, { mixins } from "vue-class-component";
import MobileMixin from "@/mixins/mobileMixin";
import MobileRapportConfig from "@/components/mobileRapportConfig.vue";
import RapportConfig from "@/components/rapportConfig.vue";
import { Site } from "@/shared/Site";

@Component({
  components: { RapportConfig, MobileRapportConfig },
})
export default class ConfigFav extends mixins(MobileMixin) {
  public groupePan: string = "TOUS";
  public error: boolean = false;
  public errorMessage: string = "";
  public avReports: any = { PDF_AVAILABLE: false, CSV_AVAILABLE: false };

  /**
   * retour à la page d'acceuil apres vérification qu'un type de rapport a été choisi
   */
  public save(rapport: any) {
    // console.log(rapport);
    rapport.id = this.rapport.id;
    if (
      rapport.typeRapport.className === "" ||
      rapport.typeRapport.localisedTitle === ""
    ) {
      this.error = true;
      this.errorMessage = this.$t("PasRapportSelectionne").toString();
    } else {
      this.$store.dispatch("rapport/updateOneFavoris", rapport);
      this.$router.push("home");
    }
  }
  /**
   * mise à jour du rapport favori selectionné
   */
  public updateRapport(rapport?: RapportFav) {
    console.log("favoris update", rapport);
  }

  public mounted() {
    if (this.rapport === undefined) {
      this.$router.push("home");
    } else {
      const locale = this.$i18n.locale;
      moment.locale(locale);
      console.log(this.rapport);
      if (this.rapport.typeSite === undefined) {
        this.rapport.typeSite = "site";
      }
      if (this.rapport.typeRapport === undefined) {
        this.rapport.typeRapport = { className: "", localisedTitle: "" };
        this.updateRapport(this.rapport);
      }
      if (this.sites.length === 1) {
        this.rapport.lSites = this.sites;
        this.updateRapport(this.rapport);
      }
      if (this.isNewFav) {
        //
      }
    }
  }

  // computed
  get rapport(): RapportFav {
    const fav = this.$store.getters["rapport/selectedFavoris"];
    return fav;
  }
  set rapport(newRap) {
    this.$store.dispatch("rapport/updateOneFavoris", newRap);
  }
  get isNewFav(): boolean {
    return this.$store.getters["rapport/isNewFavoris"];
  }
  get sites(): Site[] {
    return this.$store.getters["login/sites"];
  }
}
